/**
 * @ngdoc Service
 */
(function () {
    "use strict";

    angular.module("vrm.components").service("VrmNavService", VrmNavService);

    /* @ngInject */
    function VrmNavService(
        UserService,
        ApiService,
        $q,
        localStorageService,
        vrmUserAccessLevel
    ) {
        const service = {
            model: {
                forceOpenMenu: false,
            },
            getLatestCheckedChangelogDate: getLatestCheckedChangelogDate,
            setLatestCheckedChangelogDate: setLatestCheckedChangelogDate,
            getLastCheckedWhatsnewDate: getLastCheckedWhatsnewDate,
            setLastCheckedWhatsnewDate: setLastCheckedWhatsnewDate,
            setForceOpenMenu: setForceOpenMenu,
        };

        return service;

        function getLatestCheckedChangelogDate() {
            const lastViewedChangelogLocal =
                localStorageService.get("latestCheckedChangelogDate") || 0;

            return UserService.loading.then(function (user) {
                if (!user) {
                    return lastViewedChangelogLocal;
                }
                return user.latestCheckedChangelogDate ? user.latestCheckedChangelogDate : 0;
            });
        }

        async function setLatestCheckedChangelogDate(latestChangelogDate) {
            // Update settings locally for fast switch
            localStorageService.set(
                "latestCheckedChangelogDate",
                latestChangelogDate
            );

            const user = await UserService.getUser();
            if (user.accessLevel === vrmUserAccessLevel.DEMO) return;

            await ApiService.users("whatsnew", {
                latestCheckedChangelogDate: latestChangelogDate,
            });
            UserService.reload();
        }

        function getLastCheckedWhatsnewDate() {
            const lastCheckedWhatsnewDateLocal =
                localStorageService.get("lastCheckedWhatsnewDate") || 0;

            return UserService.loading.then(function (user) {
                if (!user) {
                    return lastCheckedWhatsnewDateLocal;
                }
                return user.lastCheckedWhatsnewDate ? user.lastCheckedWhatsnewDate : 0;
            });
        }

        async function setLastCheckedWhatsnewDate(latestWhatsnewDate) {
            // Update settings locally for fast switch
            localStorageService.set(
                "lastCheckedWhatsnewDate",
                latestWhatsnewDate
            );

            const user = await UserService.getUser();
            if (user.accessLevel === vrmUserAccessLevel.DEMO) return;

            await ApiService.users("whatsnew", {
                lastCheckedWhatsnewDate: latestWhatsnewDate,
            });
            UserService.reload();
        }

        function setForceOpenMenu(forceOpenMenu) {
            service.model.forceOpenMenu = forceOpenMenu;
        }
    }
})();
